import { useEffect, useState } from 'react';
import config from '../../common/config';
import SvgMovie from '../../../components/SvgMovie';
import './styles/Digest0.less';

const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);

  useEffect(() => {
    if (play) {
      setTimeout(() => {
        setDelayPlay(true);
      }, 300);
    } else {
      // 恢复初始化状态
      setDelayPlay(false);
    }
  }, [play]);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <div className={`digest digest-${seq}`}>
        <SvgMovie src={config.slides[seq].svgMovie} play={delayPlay} className="full-screen-svg" onDataLoaded={onDataLoaded} />
      </div>
    </div>
  );
};

export default Digest;
